import dayjs, { ConfigType, Dayjs } from 'dayjs'
import { z } from 'zod/v4'

export const daySchema = z.custom<Dayjs>((value: ConfigType) =>
  dayjs(value).isValid(),
)
